// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1eI8p","header":"ReportDetails_header__VivAz","title":"ReportDetails_title__XkBIN","left":"ReportDetails_left__o0dzO"};